export default "./dist/stdassets/cursors/digitizeRectangle.cur";